import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { Helmet } from "react-helmet";

//MUI ELEMENTS
import {
    Tooltip,
    Typography,
    Switch
} from "@mui/material";

//CUSTOM ELEMENTS
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";

class OrganizationsList extends React.Component {

    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.organizations);
        this.props.ChangeCurrentMenuName("organizations");
    }

    OnDisableOrganization(Id, onReload) {
        this.props.OpenDialog({
            title: strings.confirmDisableItem,
            description: strings.confirmDisableItemDesc,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDisable,
            onPrimaryAction: () => {
                this.props.DisableOrganization(Id, () => onReload());
            }
        });
    }

    OnEnableOrganization(Id, onReload) {
        this.props.OpenDialog({
            title: strings.enableOrg,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.Enable,
            onPrimaryAction: () => {
                this.props.EnableOrganization(Id, () => onReload());
            }
        });
    }
    getAllNames(array) {
        if (!array || array.length === 0) {return "";}

        return <div>
            {
                array.map((el, index) => {
                    let displayName = el.displayName ? el.displayName : el.email;
                    index < array.length - 1 ? displayName += "," : null;
                    return el.displayName ?
                        <Tooltip key={index} title={el.email}>
                            <p style={{ marginRight: 5, fontSize: "0.75rem" }} className="noselect">{displayName}</p>
                        </Tooltip> : <p style={{ marginRight: 5 }} >{displayName}</p>;
                })
            }
        </div>;
    }


    OnNewClick() {
        this.props.history.push("/SuperAdmin/Organization");
    }

    OnLoadClick(element) {
        this.props.history.push("/SuperAdmin/Organization?id=" + element.id);
    }

    render() {

        return <>
            <Area
                helmet={strings.helmetSuperAdmin}
                title={strings.organizations}
                sideButtons={
                    [
                        {
                            type: "primary-icon",
                            nameIcon: "add",
                            text: strings.newOrganization,
                            onClick: () => this.OnNewClick(null)
                        }
                    ]
                }
            >
                <PaginationList
                    onGetElements={this.props.GetOrganizations}
                    onSavePagination={() => {}}
                    myElements={this.props?.superAdmin?.organization?.list ?? []}

                    sortOptions={[
                        { sortName: "name", sortData: "asc" }
                    ]}

                    tableElement={(element, onReloadList) => {
                        return [
                            {
                                colTitle: strings.isDisabled,
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value) {
                                        return <Tooltip title={value.isDisabled ? strings.orgDisabled : strings.orgEnabled}>
                                            <span className="tooltipInteractive">
                                                <Switch
                                                    checked={value.isDisabled}
                                                    onChange={() => {
                                                        value.isDisabled ? this.OnEnableOrganization(value.id, value.onReloadList) : this.OnDisableOrganization(value.id, value.onReloadList);
                                                    }}
                                                    color="primary"
                                                />
                                            </span>
                                        </Tooltip>;
                                    }
                                    else {return "";}
                                },
                                colContent: element ? { isDisabled: element.isDisabled, onReloadList: onReloadList } : null
                            // onClick: !element ? null : () => this.OnLoadClick(element)
                            },
                            {
                                colTitle: strings.Users,
                                colContent: element ? element.usersCount : null,
                                colWidth: 20,
                                colNumbers: true
                            },
                            {
                                colTitle: strings.SortName,
                                sortIndex: 0,
                                colWidth: 150,
                                colContent: element ? element.name : null
                            },
                            {
                                colTitle: strings.administrators,
                                fixedWidth: "200px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value) {
                                        return this.getAllNames(value.organizationAdministrators);
                                    }
                                    else {return "";}
                                },
                                colContent: element ? { organizationAdministrators: element.organizationAdministrators } : null
                            },
                            {
                                colTitle: strings.SortActions,
                                colType: "actions",
                                actions: [0, 1],
                                colContent: [
                                    <ButtonSkaRound
                                        key={"edit"}
                                        type="primary"
                                        onClick={() => this.OnLoadClick(element)}
                                        nameIcon="edit"
                                    />,
                                    <ButtonSkaRound
                                        key={"duplicate"}
                                        type="primary"
                                        onClick={() => this.props.history.push("/SuperAdmin/Organization?id=" + element.id + "&duplicate=true")}
                                        nameIcon="duplicate"
                                    />
                                ]
                            }
                        ];
                    }}
                />
            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(OrganizationsList);
